import { CKBox, CKLayoutHorizontal } from 'clearkit';
import { ReactNode } from 'react';

import { UpgradeAccountFormButton } from '~/components/UpgradeAccountFormButton';
import { useEntitlements } from '~/hooks/account';

export default function RevealFeatureGuard({
  children,
}: {
  children: ReactNode;
}) {
  const { hasAccessLegacyRevealPlan } = useEntitlements();
  const hasAccess = hasAccessLegacyRevealPlan;

  return hasAccess ? (
    <>{children}</>
  ) : (
    <CKBox>
      <CKLayoutHorizontal className="py-6 pl-6 pr-8" wrap="nowrap">
        <div className="space-y-2">
          <h3 className="text-base font-medium text-gray-600">
            Personalization
          </h3>

          <p className="text-base text-gray-500">
            Reveal anonymous traffic and make visitor data available to the
            front end of your website to power personalization.
          </p>
          <p className="text-base text-gray-500">
            Requires access to Clearbit Reveal.
          </p>
        </div>

        <UpgradeAccountFormButton
          className="shrink-0 basis-auto"
          variant="bold"
          variantColor="blue"
        >
          Request Access
        </UpgradeAccountFormButton>
      </CKLayoutHorizontal>
    </CKBox>
  );
}
